import React from 'react';
import { useSmartFeedback } from '../contexts/SmartFeedbackContext';
import { useOptionalUpgradeModal } from '../contexts/UpgradeModalContext';
import { FeedbackModal } from './ToxicDetector/FeedbackModal';
import { UpgradeModal } from './Upgrade/UpgradeModal';
export function GlobalModals() {
  const {
    isOpen,
    milestone,
    milestoneType,
    closeFeedback
  } = useSmartFeedback();
  // The marketing entry points mount without the upgrade provider.
  const upgrade = useOptionalUpgradeModal();
  return <>
      <FeedbackModal isOpen={isOpen} milestone={milestone} milestoneType={milestoneType} onClose={closeFeedback} data-id="element-1302" data-mp="3rpl09n454ohc" />
      {upgrade ? <UpgradeModal data-id="element-1303" data-mp="4daaqnp3eagw" /> : null}
    </>;
}